import styled from "styled-components";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useProductContext } from "./Context/ProductContext";
import FormatPrice from "./Helpers/FormatPrice";
import PageNavigation from "./component/PageNavigation";
import MyImage from "./component/MyImage";
import { Container } from "./styles/Container";
import { Replace, Shield, TruckIcon } from "lucide-react";
import Stars from "./component/Star";
import AddToCart from "./component/AddToCart";

const Api = "https://api.pujakaitem.com/api/products";

const SingleProduct = () => {
  const { id } = useParams();
  const { isSingleLoading, getSingleProduct, singleProduct } =
    useProductContext();
  const {
    id: pro,
    company,
    name,
    price,
    description,
    stock,
    stars,
    reviews,
    image,
  } = singleProduct;

  useEffect(() => {
    getSingleProduct(`${Api}?id=${id}`);
  }, []);

  if (isSingleLoading) {
    return <div className="page_loading">Loading...</div>;
  }

  return (
    <Wrapper>
      <PageNavigation title={name} />
      <Container className="container">
        <div className="grid grid-two-column">
          
          {/* products image  */}
          <div className="product_images">
            <MyImage imgs={image} />
          </div>

          {/* product data  */}
          <div className="product-data" style={{margin:"2rem"}}>
            <h2>{name}</h2>
            <Stars star={stars} reviews={reviews}/>
            <p style={{fontStyle:'bold'}}>{reviews} reviews</p>

            <p className="product_price">
              MRP:
              <del>
                <FormatPrice price={price + 250000} />
              </del>
            </p>
            <p className="product-data-price product-data-real-price" style={{color:'black'}}>
              Deal of the Day: <FormatPrice price={price} />
            </p>
            <br></br>
            <p>{description}</p>

              {/* services  */}
            <div className="product-data-warranty" style={{display:'flex', justifyContent:'space-between', marginTop:'3rem'}}>
              <div className="product-warranty-data">
                <TruckIcon className="warranty-icon" style={{height:'3.6rem', width:'3.6rem', marginBottom:'.5rem' }}/>
                <p style={{fontWeight:'bold'}}>Free Delivery</p>
              </div>

              <div className="product-warranty-data">
                <Replace className="warranty-icon" style={{height:'3.6rem', width:'3.6rem', marginBottom:'.5rem' }}/>
                <p style={{fontWeight:'bold'}}>30 Days Replacement</p>
              </div>

              <div className="product-warranty-data">
                <Shield className="warranty-icon" style={{height:'3.6rem', width:'3.6rem', marginBottom:'.5rem' }}/>
                <p style={{fontWeight:'bold'}}> Safe and Secure </p>
              </div>
            </div>

                {/* stock */}
            <div className="product-data-info">
              <p>Available: <span style={{fontWeight:"bolder"}}>{stock >0?  'In Stock': "Out Of Stock"}</span></p>
            </div>
            <p>ID: <span style={{fontWeight:"bolder"}}>{id}</span></p>
            <p>Brand: <span style={{fontWeight:"bolder"}}>{company}</span></p>

          <hr></hr>
          {
            stock > 0 && <AddToCart product={singleProduct}/>
          }
          </div>
        </div>
      </Container>
    </Wrapper>
  );
};


const Wrapper = styled.section`
  background-color: #ffe;
  .container {
    padding: 9rem 0;
  }

  .product_images {
    display: flex;
    align-items: center;
  }

  .product-data {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 2rem;

    .product-data-warranty {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #ccc;
      margin-bottom: 1rem;

      .product-warranty-data {
        text-align: center;

        .warranty-icon {
          background-color: rgba(220, 220, 220, 0.5);
          border-radius: 50%;
          width: 4rem;
          height: 4rem;
          padding: 0.6rem;
        }
        p {
          font-size: 1.4rem;
          padding-top: 0.4rem;
        }
      }
    }

    .product-data-price {
      font-weight: bold;
    }
    .product-data-real-price {
      color: ${({ theme }) => theme.colors.btn};
    }
    .product-data-info {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      font-size: 1.8rem;

      span {
        font-weight: bold;
      }
    }

    hr {
      max-width: 100%;
      width: 90%;
      /* height: 0.2rem; */
      border: 0.1rem solid #000;
      color: red;
    }
  }

  .product-images {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .page_loading {
    font-size: 3.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media (max-width: ${({ theme }) => theme.media.mobile}) {
    padding: 0 2.4rem;
  }
`;

export default SingleProduct;
